const KEY = 'HS_IS_ACCEPTANCE_TEST';
const isAcceptanceTest = () => {
  try {
    return document.cookie.includes('hs_selenium') || !!localStorage.getItem(KEY);
  } catch (e) {
    return false;
  }
};
export default isAcceptanceTest;